import {
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SocialWorkerSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.contactInformation
          .titleSocialWorker
      }
    >
      <SectionRow>
        <TextInputWithLabel
          elementName="social_worker_last_name"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerName
          }
        />
        <TextInputWithLabel
          elementName="social_worker_first_name"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerFirstName
          }
        />
        <TextInputWithLabel
          elementName="social_worker_telephone"
          isBold
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerPhone
          }
          textInputType="tel"
        />
      </SectionRow>

      <SectionRow>
        <TextInputWithLabel
          elementName="social_worker_fax"
          isBold
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerFax
          }
          textInputType="tel"
        />
        <TextInputWithLabel
          elementName="social_worker_email"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerEmail
          }
        />
      </SectionRow>
    </Section>
  );
};
